import { createActionsGroup } from 'utils/redux-utils'

export const changePasswordActions = createActionsGroup('CHANGE_PASSWORD')
